/**
 * OrbDocDownloadsSkillsENDocScreenView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait OrbDocDownloadsSkillsENDocScreen
 */

import { useOrbDocDownloadsSkillsENDocScreenLogic } from '@/hooks/traits/useOrbDocDownloadsSkillsENDocScreenLogic';
import type { OrbDocDownloadsSkillsENDocScreenConfig } from '@/hooks/traits/useOrbDocDownloadsSkillsENDocScreenLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { OrbDocDownloadsSkillsENDocView as OrbDocDownloadsSkillsENDocViewEntity } from '@app/shared';
import { OrbDocDownloadsSkillsENDocBodyView } from '@/components/traits/OrbDocDownloadsSkillsENDocBodyView';
import { OrbDocDownloadsSkillsENDocFooterView } from '@/components/traits/OrbDocDownloadsSkillsENDocFooterView';
import { OrbDocDownloadsSkillsENDocHeaderView } from '@/components/traits/OrbDocDownloadsSkillsENDocHeaderView';
import { Stack } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface OrbDocDownloadsSkillsENDocScreenViewProps {
  config?: Partial<OrbDocDownloadsSkillsENDocScreenConfig>;
}

export function OrbDocDownloadsSkillsENDocScreenView({ config: propsConfig }: OrbDocDownloadsSkillsENDocScreenViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useOrbDocDownloadsSkillsENDocScreenLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['OrbDocDownloadsSkillsENDocView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="OrbDocDownloadsSkillsEN" trait="OrbDocDownloadsSkillsENDocScreen">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="OrbDocDownloadsSkillsENDocScreen">{slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="none"><OrbDocDownloadsSkillsENDocHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocDownloadsSkillsENDocBodyView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocDownloadsSkillsENDocFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default OrbDocDownloadsSkillsENDocScreenView;
